import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import { styled } from '@mui/material/styles'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import PropTypes from 'prop-types'
import CreateTaskComponent from './CreateTaskComponent'
import CreateSubTaskComponent from './CreateSubTaskComponent'
import { Stack, Stepper, Step, StepLabel, Box, useTheme } from '@mui/material'
import { useScheduled } from '../../../../shared/context/scheduledContext'
import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';


const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: '#cacfd2',
        borderRadius: 1,
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 30,
    height: 30,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey[700],
    }),
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                backgroundImage:
                    'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                backgroundImage:
                    'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
            },
        },
    ],
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, taskRealized } = props;

    const icons = {
        1: <TaskAltOutlinedIcon sx={{ fontSize: '20px' }} />,
        2: <PlaylistAddCheckOutlinedIcon sx={{ fontSize: '20px' }} />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
    taskRealized: PropTypes.bool,
};

const steps = ['Tarea', 'Subtareas'];





const stepContent = (stepActive, readOnly) => {
    const component = {
        1: <CreateTaskComponent readOnly={readOnly} />,
        2: <CreateSubTaskComponent readOnly={readOnly} />,



    }




    return component[stepActive]
}



export default function ManageTaskScheduledComponent({ readOnly }) {

    const { stepActive } = useScheduled()
    const theme = useTheme()
    return (
        <Box>
            <Stack sx={{ width: '100%', marginBottom: '2px', marginTop: '5px' }} spacing={4}>

                <Stepper alternativeLabel activeStep={stepActive - 1} connector={<ColorlibConnector />}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={(props) => <ColorlibStepIcon {...props} />}
                                sx={{ "& .MuiStepLabel-label": { fontSize: { xs: '11px', md: '14px' }, marginTop: { xs: '2px !important', md: '5px' } } }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Stack>

            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: { xs: '5px', md: '10px' },
                minHeight: '600px',
                position: 'relative'
            }}>
                
                {stepContent(stepActive, readOnly)}
            </Box>
        </Box>
    )
}